import en from 'vuetify/es5/locale/en';
import tr from 'vuetify/es5/locale/tr';

const locales = { en, tr };

export default locales;
